module.exports = __webpack_public_path__ + "img/activity12.aed3e170.png";